<template>
	<b-modal
		centered
		:id="id"
		:size="size"
		:title="title"
		header-bg-variant="primary"
		header-text-variant="white"
		ref="closeCaseModal"
		@ok.prevent="onSubmit"
		@shown="shown"
		:ok-disabled="saving"
	>
	    <h5>Summary</h5>
		<p class="mb-2" v-if="caseEntity.total_claim_amount != null">
			<span>Total Claim Amount &nbsp;&nbsp;&nbsp;:</span>
			<span><strong>${{caseEntity.total_claim_amount}}</strong></span>
		</p>
		<p class="mb-2" v-if="caseEntity.disputed_amount != null">
			<span>Initial Denial Amount &nbsp;:</span>
			<span><strong>${{caseEntity.disputed_amount}}</strong></span>
		</p>
		<!-- <p class="mb-2" v-if="finalDenailAmount != null"> -->
		<p class="mb-2" >
			<span>Final Denial Amount &nbsp;&nbsp;:</span>
			<span><strong>${{ finalDenailAmount == null ? 0 : finalDenailAmount }}</strong></span>
		</p>

		<hr/>

		<b-form id="closeCaseModal" @submit.prevent="onSubmit">
			<!-- <b-alert show variant="light">
				<font-awesome-icon icon="info-circle" fixed-width />
				<span class="ml-2">
					Cases should be closed when all appeal opportunities have been exhausted and a verdict has been
					reached.
				</span>
			</b-alert> -->

			<b-form-group
				id="caseOutcome"
				label="Reason"
				label-for="case_outcome_id"
				label-cols-lg="4"
				class="mb-4"
				label-class="font-weight-bold"
			>
				<loading-indicator v-if="loadingCaseOutcomes" />
				<b-form-checkbox-group
					name="case_outcome_id"
					v-else
					stacked
					v-model="case_outcome_ids"
					:options="caseOutcomes"
					value-field="id"
					text-field="name"
				/>
				<b-form-input
					v-if="showOutcomeInputBox"
					v-model="case_outcome_other"
					placeholder="Enter Other Outcome"
				></b-form-input>

			</b-form-group>

			<!-- <b-form-group
				id="settledAmount"
				description="Used to calculate dollars reimbursed"
				label="Settled Amount"
				label-for="settledAmount"
				label-cols-lg="4"
			>
				<b-input-group>
					<b-input-group-prepend is-text>
						<font-awesome-icon icon="dollar-sign" fixed-width />
					</b-input-group-prepend>
					<b-form-input name="settled_amount" v-model="settled_amount" type="text" autocomplete="off" />
				</b-input-group>
			</b-form-group> -->

			<template #modal-ok>
				<font-awesome-icon v-if="saving" icon="circle-notch" spin fixed-width />
				<span v-else>Close Case</span>
			</template>
		</b-form>
	</b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "CloseCaseModal",
	props: {
		id: {
			type: String,
			default: "closeCaseModal",
		},
		caseEntity: {
			type: Object,
			default: () => {
				return {
					id: null,
					closed: null,
					case_outcome_id: null,
					disputed_amount: null,
					reimbursement_amount: null,
					settled_amount: null,
					case_outcome_other:null,
					case_outcome_info:""
				};
			},
		},
		title: {
			type: String,
			default: "Close Case",
		},
		size: {
			type: String,
			default: "lg",
		},
	},
	data() {
		return {
			saving: false,
			// case_outcome_id: this.caseEntity.case_outcome_id,
			case_outcome_id : null,
			settled_amount: null,
			finalDenailAmount:null,
			showOutcomeInputBox:false,
			case_outcome_other:null,
			case_outcome_ids:[],
			case_outcome_info:"",
		};
	},
	computed: mapGetters({
		caseOutcomes: "caseOutcomes/all",
		loadingCaseOutcomes: "caseOutcomes/loadingAll",
	}),
	mounted() {
		if (this.caseEntity.settled_amount !== null) {
			this.settled_amount = this.caseEntity.settled_amount;
		} else if (this.caseEntity.reimbursement_amount !== null) {
			this.settled_amount = this.caseEntity.reimbursement_amount;
		}
		
		this.finalDenailAmt();
	},
	methods: {
		shown(e) {
			if (this.caseOutcomes.length > 0 && this.case_outcome_id == null) {
				// this.case_outcome_id = this.caseOutcomes[0].id;
			}
		},
		cancel(e) {
			this.$refs.closeCaseModal.hide();
		},
		async onSubmit(e) {
			e.preventDefault();

			try {
				this.saving = true;
			
				const response = await this.$store.dispatch("cases/close", {
					id: this.caseEntity.id,
					case_outcome_id: this.case_outcome_id,
					settled_amount: this.settled_amount,
					case_outcome_other:this.case_outcome_other,
					case_outcome_info:this.case_outcome_info,
				});

				this.$store.dispatch("updateState");

				this.$emit("closed", response);
				this.$refs.closeCaseModal.hide();
			} catch (e) {
				
				this.$store.dispatch("apiError", {
					error: e,
					title: "Close Failed",
					message: "Failed to close case.",
				});
			} finally {
				this.saving = false;
			}
		},
		reset() {
			this.case_outcome_id = null;
		},
		finalDenailAmt(){
			var lengthFinalDenailAmt = this.caseEntity.appeals.length;
			// console.log('length = ',lengthFinalDenailAmt);
			// console.log("disputed amted",this.caseEntity.appeals[lengthFinalDenailAmt-2].outstanding_amount);
			this.finalDenailAmount = this.caseEntity.appeals[lengthFinalDenailAmt-1].outstanding_amount;
		}
	},
	watch: {
		caseEntity: {
			immediate: false,
			handler(val) {
				this.case_outcome_id = val.case_outcome_id;
				this.settled_amount = val.settled_amount;
			},
		},
		case_outcome_ids: {
			immediate: false, // Whether to trigger the handler immediately upon creation
			handler(newVal, oldVal) {
			
			this.caseOutcomes.forEach(element => {
				if(element.id == newVal){
					if(element.name === "Others"){
						
						this.showOutcomeInputBox = true;
					}
					else{
						this.showOutcomeInputBox = false;
					}
				}
				
			});
			// You can perform any actions or call methods here
			}
		},
		case_outcome_ids:{
			immediate: false, // Whether to trigger the handler immediately upon creation
			handler(newVal, oldVal) {
				
				if (newVal.length < oldVal.length) {
					let newIdStr = this.case_outcome_info.toString();
					// Find the last occurrence of '0'
					const lastZeroIndex = newIdStr.lastIndexOf('%');
					
					if (lastZeroIndex !== -1) {
						// Truncate the string up to the last %
						newIdStr = newIdStr.substring(0, lastZeroIndex);
						
					}
					this.case_outcome_info = newIdStr; 
					
				}
				if (newVal.length > oldVal.length) {
					let newIdStr = this.case_outcome_id == null ? "" : this.case_outcome_id.toString();
					
					this.case_outcome_info += '%'+newVal[(newVal.length) - 1];
					
					 
					
				}
				this.case_outcome_id = newVal[(newVal.length) - 1];
				newVal.forEach((item , index)=>{
					if(item == 9 || item == 13){
						this.showOutcomeInputBox = true;
					}
				});
			}
		}
	},
};
</script>